/*global _ */
import component from '../../../../../props/component'

const localProps = {
  classes: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('status.classes', '')
    }
  },
  title: {
    type: String,
    default() {
      return this.$options.$$t('status.title', '')
    }
  },
  pluralizeTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.pluralizeTitle', false)
    }
  },
  showTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showTitle', false)
    }
  },
  showPrefix: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showPrefix', false)
    }
  },
  showSuffix: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showSuffix', false)
    }
  },
  prefix: {
    type: String,
    default() {
      return this.$options.$$t('status.prefix', '')
    }
  },
  pluralizePrefix: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.pluralizePrefix', false)
    }
  },
  suffix: {
    type: String,
    default() {
      return this.$options.$$t('status.suffix', '')
    }
  },
  pluralizeSuffix: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.pluralizeSuffix', false)
    }
  },
  showVisualization: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showVisualization', true)
    }
  },
  showProgressBar: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showProgressBar', true)
    }
  },
  // For Tier rewards: show earned points and target points to reach next level
  // 2022 version
  showValues: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showValues', true)
    }
  },
  // show a single value (earned points or a custom value)
  // 2025 version
  showValue: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showValue', false)
    }
  },
  // Formatting value
  valueFormat: {
    type: [String, Array, Object],
    default() {
      let $t = this.$options.$$t('status.valueFormat', {})
      let $s = this.$options.$$s('status.valueFormat', {})
      if (_.isString($s)) {
        $s = {valuePath: $s}
      }
      if (_.isString($t)) {
        $t = {valuePath: $t}
      }
      return _.merge({}, $t, $s)
    }
  },
  showMessages: {
    type: [Boolean, Number, String],
    default() {
      const $s = this.$options.$$s('status.showMessages', null)
      return _.isNil($s) ? $s : !!$s
    }
  },
  showShortMessage: {
    type: [Boolean, Number, String],
    default() {
      const $s = this.$options.$$s('status.showShortMessage', null)
      return _.isNil($s) ? $s : !!$s
    }
  },
  shortMessageTemplate: {
    type: String,
    default() {
      return this.$options.$$t('status.shortMessageTemplate', null)
    }
  },
  showLongMessage: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showLongMessage', true)
    }
  },
  longMessageTemplate: {
    type: String,
    default() {
      return this.$options.$$t('status.longMessageTemplate', null)
    }
  },
  showFulfilledMessage: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.showFulfilledMessage', true)
    }
  },
  fulfilledMessageTemplate: {
    type: String,
    default() {
      return this.$options.$$t('status.fulfilledMessageTemplate', null)
    }
  },

  longMessagePrefix: {
    type: String,
    default() {
      return this.$options.$$t('status.longMessagePrefix', null)
    }
  },
  longMessageSuffix: {
    type: String,
    default() {
      return this.$options.$$t('status.longMessageSuffix', null)
    }
  },
  loadingMessage: {
    type: String,
    default() {
      return this.$options.$$t('status.loadingMessage', 'Loading')
    }
  },
  announceRewards: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('status.announceRewards', false)
    }
  },
  skipAnnounceOnPages: {
    type: [String, Array],
    default() {
      return this.$options.$$s('status.skipAnnounceOnPages', ['sign-in'])
    }
  },
  // tier, achievements
  type: {
    type: String,
    default() {
      return this.$options.$$s('status.type', 'tier')
    }
  },
  // where this status is placed (page-header, menu, page-inline etc.)
  position: {}
}
export const props = {
  ...component,
  ...localProps
}
export default props
